import React, { useCallback, useEffect } from 'react';
import ReactGA from 'react-ga';
import { Router } from 'reaouter'; 
import { Main } from './Main';
import { Session } from './Storage/Session';

const App = () => {

	useEffect(() => {
		ReactGA.initialize('UA-125506794-2')
	}, [])

	const handleUpdate = useCallback((event) => {
		if(process.env.NODE_ENV === 'production')
			ReactGA.pageview(event.url + window.location.search)
	}, [])
	
	return (
		<Router onUpdate={handleUpdate}>
			<Session>
				<Main />
			</Session>
		</Router>
	);
}
export default App;
